module.exports = __webpack_public_path__ + "img/ico_warning_box.9cd2a74.svg";